import {Icon} from '@/app/components/Icon';
import {useState} from 'react';
import {Button, type ButtonProps} from '@/components/app/button';
import {Modal} from '@/components/app/modal';
import {useGetBiotwinSharesQuery} from '../../../app/services/biotwinShareApi';
import {useSession} from '../../auth/hooks/useSession';
import {BiotwinShareInfo} from './BiotwinShareInfo';
import {BiotwinShareStatus} from '../types';
export interface PendingBiotwinSharesButtonProps extends ButtonProps {}
export const PendingBiotwinSharesButton = (props: PendingBiotwinSharesButtonProps) => {
  const session = useSession();
  const {data: biotwinShares = []} = useGetBiotwinSharesQuery();
  const [dialogVisible, setDialogVisible] = useState(false);
  const pendingBiotwinShares = biotwinShares.filter(({status}) => status === BiotwinShareStatus.Pending);
  const incomingBiotwinShares = pendingBiotwinShares.filter(({ownerId}) => ownerId !== Number(session?.id));
  const outgoingBiotwinShares = pendingBiotwinShares.filter(({ownerId}) => ownerId == Number(session?.id));
  return (
    <>
      <Modal
        title={'Shared Biotwins'}
        onClose={() => setDialogVisible(false)}
        style={{
          maxWidth: 'calc(100% - 3rem)',
          width: '40rem',
        }}
        open={dialogVisible}
      >
        <div className="flex flex-wrap -mx-3 -mt-3">
          <div className="w-full px-3 pt-3">
            <h6 className={'text-base my-2'}>Shared With Me</h6>
            {incomingBiotwinShares.length === 0 && (
              <p className={'text-muted-foreground mb-0'}>There are no pending biotwin shares.</p>
            )}
            {incomingBiotwinShares.map((biotwinShare) => (
              <BiotwinShareInfo
                biotwinShare={biotwinShare}
                className={'border-b border-zinc-100 py-4'}
                key={biotwinShare.id}
              />
            ))}
          </div>
          <div className="w-full px-3 pt-3">
            <h6 className={'text-base my-2'}>Shared With Others</h6>
            {outgoingBiotwinShares.length === 0 && (
              <p className={'text-muted-foreground mb-0'}>There are no pending biotwin shares.</p>
            )}
            {outgoingBiotwinShares.map((biotwinShare) => (
              <BiotwinShareInfo
                biotwinShare={biotwinShare}
                className={'border-b border-zinc-100 py-4'}
                key={biotwinShare.id}
                noMessage
              />
            ))}
          </div>
        </div>
      </Modal>
      <Button
        {...props}
        badge={incomingBiotwinShares.length > 0 ? `${incomingBiotwinShares.length}` : undefined}
        onClick={() => setDialogVisible(!dialogVisible)}
        type={'button'}
        startIcon={<Icon icon={'users'} />}
        aria-label={'Pending shares'}
        size="icon"
      />
    </>
  );
};
